import * as React from 'react';
import { txt } from '../../txt';
import { AmorgUserRole, PermissionGroup } from '../../amorg-common';
import { TextAvatarSize } from './TextAvatar';
import { UserAvatar } from './UserAvatar';

type FullUserAvatarProps = {
    user:{
        id:string,
        firstname:string,
        lastname:string,
        initials:string,
        permissionGroup: PermissionGroup,
        currentRole: AmorgUserRole | null,
    }
    backgroundColorOverride?: string,
    size?: TextAvatarSize,
    selected?:boolean,
    noTooltip?:boolean,
    onClick?: (identifier:string) => void
};

export function FullUserAvatar (props: FullUserAvatarProps): JSX.Element
{
    return (
        <UserAvatar size={props.size || '32px'}
            user={{
                displayName: `${props.user.firstname} ${props.user.lastname}`,
                initials: props.user.initials,
            }}
            identifier={props.user.id}
            selected={props.selected}
            onClick={props.onClick}
            backgroundColorOverride={props.backgroundColorOverride}
            noToolTip={props.noTooltip}
            extraTooltipRows={
                [   `${txt.getDynamic('PermissionGroupId_' +props.user.permissionGroup.id)}`,
                    props.user.currentRole ? `(${props.user.currentRole.title})` : ''
                ]
            }
        />
    );
}
